import "core-js/modules/es.string.starts-with.js";
import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import Search from '@/components/renewal/header/search/search.vue';
import SiteMenu from '@/components/renewal/header/site-menu.vue';
import Logo from '@/components/renewal/common/logo.vue';
import NavigationAnnounce from '@/components/renewal/header/navigation-announce.vue';
import NavigationHelp from '@/components/renewal/header/navigation-help.vue';
import NavigationAccount from '@/components/renewal/header/navigation-account.vue';
import Icon from '@/components/renewal/common/icon.vue';
import { ImpressionDetector } from '@/utils/impressionUtils';
import { useTelemetry } from '@/plugins/telemetry';
export default /*#__PURE__*/_defineComponent({
  __name: 'site-header',
  props: {
    layout: null
  },
  setup: function setup(__props) {
    var props = __props;
    var collapsedHeader = ref(props.layout === 'document');
    var collapsedSearch = ref(true);
    var search = ref(null);
    // body のスクロールが固定されているかどうか
    // 検索から W&H の切り替え時にスクロール位置が変動してしまうのを防ぐため
    var bodyFixed = ref(false);
    var fixBody = function fixBody() {
      // スクロールできないようにする
      var body = document.body;
      var scrollY = window.scrollY;
      body.style.position = 'fixed';
      body.style.top = "-".concat(scrollY, "px");
      body.style.left = '0';
      body.style.right = '0';
    };
    var unfixBody = function unfixBody() {
      // スクロールできるようにする
      var body = document.body;
      var scrollY = body.style.top;
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    };
    var handleChangeVariant = function handleChangeVariant(newVariant) {
      var collapsed = newVariant.startsWith('collapsed');
      if (collapsed) {
        unfixBody();
        bodyFixed.value = false;
      } else if (bodyFixed.value === false) {
        fixBody();
        bodyFixed.value = true;
      }
      collapsedSearch.value = collapsed;
    };
    var handleClickShadow = function handleClickShadow() {
      var _search$value;
      (_search$value = search.value) === null || _search$value === void 0 ? void 0 : _search$value.collapse();
    };
    var expandHeader = function expandHeader() {
      collapsedHeader.value = false;
    };
    var collapseHeader = function collapseHeader() {
      collapsedHeader.value = true;
    };
    var impressionDetector = ref();
    var telemetry = useTelemetry();
    var route = useRoute();
    var intersectionObserver = ref(null);
    onMounted(function () {
      if (!intersectionObserver.value) {
        return;
      }
      impressionDetector.value = new ImpressionDetector(telemetry, route, intersectionObserver.value,
      // 任意の領域が 100 ミリ秒以上表示されたらインプレッションイベントを送る
      0, 100, 'site-header', '2');
    });
    onBeforeUnmount(function () {
      var _impressionDetector$v;
      (_impressionDetector$v = impressionDetector.value) === null || _impressionDetector$v === void 0 ? void 0 : _impressionDetector$v.cleanup();
    });
    return {
      __sfc: true,
      props: props,
      collapsedHeader: collapsedHeader,
      collapsedSearch: collapsedSearch,
      search: search,
      bodyFixed: bodyFixed,
      fixBody: fixBody,
      unfixBody: unfixBody,
      handleChangeVariant: handleChangeVariant,
      handleClickShadow: handleClickShadow,
      expandHeader: expandHeader,
      collapseHeader: collapseHeader,
      impressionDetector: impressionDetector,
      telemetry: telemetry,
      route: route,
      intersectionObserver: intersectionObserver,
      Search: Search,
      SiteMenu: SiteMenu,
      Logo: Logo,
      NavigationAnnounce: NavigationAnnounce,
      NavigationHelp: NavigationHelp,
      NavigationAccount: NavigationAccount,
      Icon: Icon
    };
  }
});